/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface ITabPanelProps {
	children?: React.ReactNode;
	className?: string;
	value?: string;
	id?: string;
	unmountOnExit?: boolean;
}

export const TabPanel: React.FC<ITabPanelProps> = ({ children, className, value, id, unmountOnExit }) => {
	const baseClass = BEM("edt-tab-panel");
	const hidden = value !== id;

	if (className) {
		baseClass.add(className);
	}

	if (unmountOnExit && hidden) {
		return null;
	}

	return (
		<div role="tabpanel" hidden={hidden} className={baseClass.toClassName()}>
			{!hidden && children}
		</div>
	);
};
